import CustomStyle from '@/components/Common/CustomStyle';
import AppVersion from '@/components/Common/AppVersion';

export default {
  name: 'LayoutWrapper',
  components: {
    CustomStyle,
    AppVersion,
  },
  props: {
    brandTheme: Object,
    brandLogo: String,
    logoAboveForm: String,
    supportEmail: null,
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/LayoutWrapper/component.js